<template>
  <div class>
    <div class="tab-content">
      <!-- 服务能力 -->
      <div class="tab-content__skill">
        <div
          class="align-items-center"
          :class="showSkillLevel ? 'mb20' : 'mb16'"
        >
          <span
            class="title ellipsis"
            :class="{ 'space': (activeSkillItem.name && activeSkillItem.name.length>140)}"
          >
            {{ activeSkillItem.name }}
          </span>
        </div>
        <div
          v-if="showSkillLevel"
          class="info"
          v-text="activeSkillItem.description"
        />
        <div
          v-else
          class="no-skill-container"
        >
          <div
            class="mb16"
          >
            <div class="label mb8">
              {{ $t('pc_gwnl_global_lbl_skillDescription') }}
            </div>
            <div
              class="info"
              v-text="activeSkillItem.description"
            />
          </div>
          <div v-if="activeSkillItem.behavior">
            <div class="label mb8">
              {{ $t('pc_gwnl_global_lbl_behavior') }}
            </div>
            <div
              class="info"
              v-text="activeSkillItem.behavior"
            />
          </div>
        </div>
      </div>
      <!-- 能力等级 -->
      <div
        v-if="activeSkillItem&&activeSkillItem.levelList&&activeSkillItem.levelList.length>0&&showSkillLevel"
        class="pt32 border-top-gray-4"
      >
        <div
          v-for="(item, index) in formatSkillItem || []"
          :key="index"
        >
          <skill-level
            :item="item"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import skillLevel from './skillLevel';

export default {
  components: { skillLevel },
  props: {
    activeSkillItem: {
      type: Object,
      default: () => {}
    },
    showSkillLevel: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    formatSkillItem() {
      return this.activeSkillItem.levelList && this.activeSkillItem.levelList.map(item => {
        return {
          ...item,
          current: item.level === (Number(this.activeSkillItem.stdLevel) || Number(this.activeSkillItem.standardLevel)) || (item.name === this.activeSkillItem.standardLevelName)
        };
      });
    }
  }
};
</script>
<style scoped lang="scss">
.title {
  color: #262626;
  font-weight: 500;
  font-size: 18px;
  line-height: 26px;
}

.align-items-center {
  display: flex;
  align-items: center;
}

.info {
  color: #8c8c8c;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  white-space: pre-wrap;
  word-break: break-all;
}

.tab-content {
  margin-bottom: -40px;

  .tab-content__skill {
    padding: 32px 0;

    &:first-child {
      padding-top: 0;
    }
  }

  .no-skill-container {
    .label {
      color: #8c8c8c;
      font-weight: 400;
      font-size: 14px;
      line-height: 22px;
    }

    .info {
      color: #595959;
      font-weight: 400;
      font-size: 14px;
      line-height: 22px;
      white-space: pre-wrap;
      word-break: break-all;
    }
  }

  .space {
    flex: 1;
  }
}
</style>
